import React, { useState, useEffect } from "react";
import { calculateAmount } from "../../utils/listePrix";

const ArticleCreateStep1 = ({
  formArticle,
  photos,
  handleChange,
  categories,
  movePhoto,
  removePhoto,
  handlePhotos,
  rotatePhoto,
  amount,
  setAmount,
  categoriGroup,
  selectedGroupId,
  setSelectedGroupId,
  setHasPrice,
  hasPrice,
  validateField,
  setfieldErrors,
  fieldErrors
}) => {
  const [showCategoryModal, setShowCategoryModal] = useState(false);
  const [activeGroup, setActiveGroup] = useState(null);

  const filteredCategories = selectedGroupId
    ? categories.filter((cat) => cat.idCategorieGroupe?._id === selectedGroupId)
    : "";

  useEffect(() => {
    const selectedCat = categories.find(
      (cat) => cat._id === formArticle.idCategorie,
    );
    const categoriePremium = selectedCat?.premium === 1; // 1 = Premium, 2 = Standard
    const havingPrice = selectedCat?.hasPrice === 1; // 1 = Oui, 2 = Non
    setHasPrice(havingPrice ? 1 : 2);
    const nbrPhotos = photos.length;
    // let newAmount = categoriePremium ? 4000 : 2000;
    let newAmount = selectedCat?.prixAbonnement;
    setAmount(newAmount);
  }, [photos, formArticle.idCategorie, categories, setAmount]);

  const normalizeDigits = (v) => {
    const digitsOnly = String(v ?? "").replace(/[^\d]/g, "");
    return digitsOnly.replace(/^0+(?=\d)/, "");
  };

  const formatThousands = (digits) => {
    const d = normalizeDigits(digits);
    if (!d) return "";
    return d.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  };

  const handlePriceChange = (e) => {
    const normalized = normalizeDigits(e.target.value);

    handleChange({
      target: { name: "prix", value: normalized },
    });
  };

  return (
    <div className="container">
      <div className="article_create_form_section_create">
        {/* Ajouter ici le nouveau design */}
        <select
          value={selectedGroupId}
          onChange={(e) => setSelectedGroupId(e.target.value)}
          className="article_create_modern_input"
        >
          <option value="">Tous les groupes</option>

          {categoriGroup
            .sort((a, b) => a.rang - b.rang)
            .map((group) => (
              <option key={group._id} value={group._id}>
                {group.nom}
              </option>
            ))}
        </select>

        <select
          name="idCategorie"
          value={formArticle.idCategorie}
          onChange={handleChange}
          className="article_create_modern_input"
        >
          <option value="">Veuillez choisir une catégorie</option>

          {filteredCategories != "" &&
            filteredCategories
              .sort((a, b) => a.rang - b.rang)
              .map((cat) => (
                <option key={cat._id} value={cat._id}>
                  {cat.nom}
                </option>
              ))}
        </select>

        <input
          name="pseudo"
          defaultValue={formArticle.pseudo}
          placeholder="Votre Pseudo"
          onBlur={(e) =>
            validateField({
              e,
              minLength: 4,
              label: "pseudo",
              setErrors: setfieldErrors,
              handleUpdateChange: handleChange,
            })
          }
          className={`article_create_modern_input ${
              fieldErrors.pseudo ? "is-invalid" : ""
            }`}
        />
        {fieldErrors.pseudo && (
          <div className="invalid-feedback" style={{marginTop:"-5px", marginBottom:"20px"}}>
            Le pseudo doit contenir au moins 4 caractères
          </div>
        )}

        <input
          name="titre"
          defaultValue={formArticle.titre}
          placeholder="Titre"
          onBlur={(e) =>
            validateField({
              e,
              minLength: 4,
              label: "titre",
              setErrors: setfieldErrors,
              handleUpdateChange:handleChange,
            })
          }
          className={`article_create_modern_input ${
              fieldErrors.titre ? "is-invalid" : ""
            }`}
        />
        {fieldErrors.titre && (
          <div className="invalid-feedback" style={{marginTop:"-5px", marginBottom:"20px"}}>
            Le titre doit contenir au moins 4 caractères
          </div>
        )}

        <textarea
          name="description"
          value={formArticle.description}
          placeholder="Description..."
          onChange={handleChange}
          className="article_create_modern_input article_create_modern_textarea"
        />
      </div>

      <div className="article_create_form_section_create">
        Photos: Une annonce avec photo est plus consultée qu’une annonce sans
        <div className="photo-flex-container">
          {photos.map((p, i) => (
            <div key={i} className="photo-card-flex" style={{ border: "none" }}>
              <img
                src={p.url}
                className="photo-uploaded"
                alt="upload"
                style={{
                  transform: `rotate(${p.rotation || 0}deg)`,
                  transition: "transform .2s ease",
                  transformOrigin: "center",
                }}
              />

              <div className="photo-controls">
                <button
                  type="button"
                  onClick={() => movePhoto(i, -1)}
                  disabled={i === 0}
                >
                  <i className="bi bi-arrow-left-short"></i>
                </button>

                <button
                  type="button"
                  onClick={() => rotatePhoto(i, -90)}
                  title="Tourner à gauche"
                >
                  <i className="bi bi-arrow-counterclockwise"></i>
                </button>

                <button
                  type="button"
                  onClick={() => rotatePhoto(i, 90)}
                  title="Tourner"
                >
                  <i className="bi bi-arrow-clockwise"></i>
                </button>

                <button
                  type="button"
                  onClick={() => removePhoto(i)}
                  className="btn-del"
                >
                  <i className="bi bi-trash3"></i>
                </button>

                <button
                  type="button"
                  onClick={() => movePhoto(i, 1)}
                  disabled={i === photos.length - 1}
                >
                  <i className="bi bi-arrow-right-short"></i>
                </button>
              </div>

              {i === 0 && (
                <span className="main_label_principale">couverture</span>
              )}
              <span
                className="main_label_principale bg-danger "
                style={{ top: "0", left: "auto", right: "0" }}
              >
                {i + 1}
              </span>
            </div>
          ))}

          {photos.length < 10 && (
            <label className="photo-upload-card-flex">
              <div className="content-btn-add-photo">
                {/* <span>{10 - photos.length} supplémentaires</span> */}
                <span>Ajouter plus d'images</span>
                <i className="bi bi-image icon_add_photo"></i>
                <input
                  type="file"
                  multiple
                  hidden
                  onChange={handlePhotos}
                  accept="image/*"
                />
                {/* <span>{amount.toLocaleString()} MGA</span> */}
              </div>
            </label>
          )}
        </div>
      </div>

      {/* SECTION ETAT / PRIX */}
      <div className="d-flex flex-column flex-md-row gap-3 align-items-center mt-3">
        <select
          name="etat"
          value={formArticle.etat}
          onChange={handleChange}
          className="article_create_modern_input form-select"
        >
          <option value={1}>Neuf</option>
          <option value={2}>Occasion</option>
        </select>

        <div className={`input-group ${hasPrice==2 ? "d-none":""}`} >
          <input
            type="text"
            name="prix"
            value={formatThousands(formArticle.prix)}
            placeholder="Prix"
            onChange={handlePriceChange}
            className="article_create_modern_input form-control"
            style={{ height: "50px" }}
            inputMode="numeric"
            pattern="[0-9]*"
            autoComplete="off"
          />
          <span
            className="input-group-text"
            style={{ height: "50px", borderRadius: "0 15px 15px 0" }}
          >
            MGA
          </span>
        </div>
      </div>
    </div>
  );
};

export default ArticleCreateStep1;

{
  /* <div className="custom-category-select">
          <div
            className="category-input-display"
            onClick={() => setShowCategoryModal(true)}
          >
            {formArticle.idCategorie
              ? categories.find((c) => c._id === formArticle.idCategorie)?.nom
              : "Catégorie"}
          </div>

          {showCategoryModal && (
            <div className="category-modal-overlay">
              <div className="category-modal-box">
                <div className="category-left">
                  {categoriGroup
                    .sort((a, b) => a.rang - b.rang)
                    .map((group) => (
                      <div
                        key={group._id}
                        className={`category-group-item ${
                          activeGroup?._id === group._id ? "active" : ""
                        }`}
                        onClick={() => setActiveGroup(group)}
                      >
                        {group.nom}
                        {activeGroup?._id === group._id && <span className="fleche-icon"><i class="bi bi-caret-right"></i></span>}
                      </div>
                    ))}
                </div>

                <div className="category-right">
                  {categories
                    .filter(
                      (cat) => cat.idCategorieGroupe?._id === activeGroup?._id,
                    )
                    .sort((a, b) => a.rang - b.rang)
                    .map((cat) => (
                      <div
                        key={cat._id}
                        className="category-sub-item"
                        onClick={() => {
                          handleChange({
                            target: { name: "idCategorie", value: cat._id },
                          });
                          setShowCategoryModal(false);
                        }}
                      >
                        {cat.nom}
                      </div>
                    ))}
                </div>

                <button
                  className="category-close-btn"
                  onClick={() => setShowCategoryModal(false)}
                >
                  ✕
                </button>
              </div>
            </div>
          )}
        </div> */
}
